import { render } from "./Trailer.vue?vue&type=template&id=49203338"
import script from "./Trailer.vue?vue&type=script&lang=js"
export * from "./Trailer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__